import { createStore } from "vuex";

import modules from "./modules";

const store = createStore({
  modules,
  strict: process.env.NODE_ENV !== "production",
  state() {
    return {
      msalConfig: {
        auth: {
          clientId: process.env.MSAL_CLIENT_ID,
          authority: process.env.MSAL_AUTHORITY,
          redirectUri: process.env.MSAL_REDIRECT_URI,
        },
        cache: {
          cacheLocation: "sessionStorage",
        },
      },
      accessToken: "",
    };
  },
  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token;
    },
  },
});

export default store;
